var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "function-list area"
  }, [_c("div", {
    staticClass: "left-list"
  }, [_c("div", {
    staticClass: "swiper-container"
  }, [_c("div", {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.listLen, function (items, index) {
    return _c("div", {
      key: index,
      staticClass: "swiper-slide"
    }, _vm._l(_vm.List.slice((items - 1) * 9, 9 * items), function (item, index) {
      return _c("div", {
        key: index,
        staticClass: "list-item",
        class: [_vm.activeKey === _vm.componentType + item._id ? "active-bg" : ""],
        on: {
          click: function ($event) {
            $event.stopPropagation();
            return _vm.viewDetail(item, "img", _vm.componentType);
          }
        }
      }, [_c("h4", {
        staticClass: "puhui-M",
        class: [_vm.activeKey === _vm.componentType + item._id ? "active-title" : ""]
      }, [_vm._v(" " + _vm._s(item.component_name) + " ")]), _c("div", {
        staticClass: "desc"
      }, [_vm._v(_vm._s(item.component_explain ? item.component_explain : ""))]), _c("div", {
        staticClass: "btn",
        class: [_vm.activeKey === _vm.componentType + item._id ? "active-btn" : ""],
        on: {
          click: function ($event) {
            $event.stopPropagation();
            return _vm.viewDetail(item, "detail", _vm.componentType);
          }
        }
      }, [_c("span", {
        staticClass: "btn-see"
      }, [_vm._v("查看详情")]), _c("a-icon", {
        staticClass: "right-icon",
        attrs: {
          type: "right"
        }
      })], 1)]);
    }), 0);
  }), 0), _vm.listLen > 1 ? _c("div", {
    staticClass: "swiper-pagination"
  }) : _vm._e()])]), _c("div", {
    staticClass: "right-card"
  }, [_c("div", {
    staticClass: "swiper-container-img"
  }, [_c("div", {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.componentUrlList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "swiper-slide"
    }, [_c("img", {
      attrs: {
        src: item,
        alt: ""
      }
    })]);
  }), 0), _vm.componentUrlList.length > 1 ? _c("div", {
    staticClass: "swiper-pagination-img"
  }) : _vm._e()]), _vm.isPC ? _c("div", {
    staticClass: "pc-img"
  }, [_c("span", [_vm._v("PC产品，见详情")])]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };